// extracted by mini-css-extract-plugin
export default {"arrowBtn":"arrow-button_arrowBtn__BO-yO"};